import { Line } from 'react-chartjs-2';
import { Chart, ChartData, ChartOptions, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement, PointElement} from "chart.js";
import { StatsChartData } from 'models/StatisticChart';
import LegendCustom from '../Components/LegendCustom';

Chart.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement, PointElement);

const LineChart = ({labels, datasets}:StatsChartData) => {
    const chartData: ChartData<'line'> = {
            labels,
            datasets
        }
    
        const chartOptions: ChartOptions<'line'> = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'right',
                    display: false
                }
            }
        }
    
        return (
            <div className='row mb-2'>
                <div className="col-md-8">
                    <div style={{width: '100%', height: '300px'}}>
                        <Line data={chartData} options={chartOptions} />
                    </div>
                </div>
                <div className="col-md-4">
                    <LegendCustom datasets={datasets} />
                </div>
            </div>
            
        )
}

export default LineChart;